import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isAdmin = user?.role?.role_type === 'admin' || user?.role?.role_type === 'founder' || user?.role?.role_type === 'deputy_admin' || user?.role?.role_type === 'account_manager';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  const handleNavClick = () => {
    // Fermer la sidebar sur mobile après navigation
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay pour mobile - cliquable pour fermer */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed lg:relative
        w-64 h-full
        bg-gradient-to-b from-blue-900 to-blue-950 text-white 
        flex flex-col
        transition-transform duration-300 ease-in-out
        z-50
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        {/* Header avec bouton fermer sur mobile */}
        <div className="p-6 border-b border-blue-800 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo-bkb.jpg" alt="Bank Kreiz Breizh" className="w-14 h-14 rounded-lg object-cover shadow-lg" />
            <div>
              <h2 className="font-bold text-lg">BKB</h2>
              <p className="text-xs text-gray-300">Bank Kreiz Breizh</p>
            </div>
          </div>
          
          {/* Bouton fermer - visible seulement sur mobile */}
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-lg hover:bg-blue-800 transition-colors"
            aria-label="Fermer le menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 overflow-y-auto">
        <NavLink
          onClick={handleNavClick}
          to="/dashboard/overview"
          onClick={handleNavClick}
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">📊</span>
          <span>Vue d'ensemble</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/accounts"
          onClick={handleNavClick}
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">🏦</span>
          <span>Comptes</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/transactions"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">💸</span>
          <span>Transactions</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/recurring-transfers"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">🔄</span>
          <span>Virements récurrents</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/cards"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">💳</span>
          <span>Cartes bancaires</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/investments"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">📈</span>
          <span>Investissements</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/insurances"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">🛡️</span>
          <span>Assurances</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/loans"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">💰</span>
          <span>Crédits</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/dashboard/elb-wallet"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">💎</span>
          <span>e-£B Wallet</span>
        </NavLink>

        <NavLink
          onClick={handleNavClick}
          to="/mobile-pay"
          className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
            isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
          }`}
        >
          <span className="text-xl">📱</span>
          <span>Paiements mobiles</span>
        </NavLink>

        {isAdmin && (
          <>
            <NavLink
              onClick={handleNavClick}
              to="/dashboard/staff"
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
                isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
              }`}
            >
              <span className="text-xl">👥</span>
              <span>Gestion Personnel</span>
            </NavLink>
            <NavLink
              onClick={handleNavClick}
              to="/dashboard/admin"
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
                isActive ? 'bg-blue-800 text-white' : 'text-gray-300 hover:bg-blue-800/50'
              }`}
            >
              <span className="text-xl">⚙️</span>
              <span>Gestion Admin</span>
            </NavLink>
          </>
        )}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-blue-800">
        <button
          onClick={handleLogout}
          className="w-full px-4 py-3 bg-red-600 hover:bg-red-700 rounded-lg font-semibold transition-colors"
        >
          Déconnexion
        </button>
      </div>
      </div>
    </>
  );
}

export default Sidebar;
